/**
 * UD Event Design Tool Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UploadAttachmentResponse} from '../models/UploadAttachmentResponse';

export interface AddAttachmentToEvent$Request {
    eventId: number;
    file: File | File[];
}

export interface AddAttachmentToEvent$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
    onProgress?: (progress: ProgressEvent) => void;
}

export const addAttachmentToEventRequest = createAction<PayloadData<void, AddAttachmentToEvent$Request>>('TRIGGER_ATTACHMENT_CONTROLLER__ADD_ATTACHMENT_TO_EVENT__REQUEST');
export const addAttachmentToEventSuccess = createAction<PayloadData<void, AddAttachmentToEvent$Request>>('TRIGGER_ATTACHMENT_CONTROLLER__ADD_ATTACHMENT_TO_EVENT__SUCCESS');
export const addAttachmentToEventFailure = createAction<PayloadData<Error, AddAttachmentToEvent$Request, true>>('TRIGGER_ATTACHMENT_CONTROLLER__ADD_ATTACHMENT_TO_EVENT__FAILURE');

export const addAttachmentToEventActions = [
    addAttachmentToEventRequest,
    addAttachmentToEventSuccess,
    addAttachmentToEventFailure
] as const;

/**
 * Admin-only operation. Uploads attachment and saves it directly to the event without a change request.
 * @param {number} meta.eventId Event ID to attach the file to
 * @param {any} meta.file The attachment file to upload
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 * @param {function(ProgressEvent): void} [config.onProgress]
 */
export const addAttachmentToEvent = (meta: AddAttachmentToEvent$Request, config?: AddAttachmentToEvent$Config) => {
    const TRANSPORT_REQUEST_FILE = {
        file: meta.file,
    };
    return {
        UPLOAD_FILE: {
            types: addAttachmentToEventActions,
            method: ApiMethods.POST,
            endpoint: `/attachments/events/${meta.eventId}/save`,
            TRANSPORT_REQUEST_FILE,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            onProgress: config?.onProgress,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAttachmentByName$Request {
    name: string;
}

export interface GetAttachmentByName$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAttachmentByNameRequest = createAction<PayloadData<void, GetAttachmentByName$Request>>('TRIGGER_ATTACHMENT_CONTROLLER__GET_ATTACHMENT_BY_NAME__REQUEST');
export const getAttachmentByNameSuccess = createAction<PayloadData<any, GetAttachmentByName$Request>>('TRIGGER_ATTACHMENT_CONTROLLER__GET_ATTACHMENT_BY_NAME__SUCCESS');
export const getAttachmentByNameFailure = createAction<PayloadData<void, GetAttachmentByName$Request, true>>('TRIGGER_ATTACHMENT_CONTROLLER__GET_ATTACHMENT_BY_NAME__FAILURE');

export const getAttachmentByNameActions = [
    getAttachmentByNameRequest,
    getAttachmentByNameSuccess,
    getAttachmentByNameFailure
] as const;

/**
 * Returns the trigger attachment content
 * @param {string} meta.name UUID of the trigger attachment
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAttachmentByName = (meta: GetAttachmentByName$Request, config?: GetAttachmentByName$Config) => {
    return {
        DOWNLOAD_FILE: {
            types: getAttachmentByNameActions,
            method: ApiMethods.GET,
            endpoint: `/attachments/content/${meta.name}/preview`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'image/png',
            }
        },
        ...meta
    }
};

export interface GetAttachmentPreviewByName$Request {
    name: string;
}

export interface GetAttachmentPreviewByName$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAttachmentPreviewByNameRequest = createAction<PayloadData<void, GetAttachmentPreviewByName$Request>>('TRIGGER_ATTACHMENT_CONTROLLER__GET_ATTACHMENT_PREVIEW_BY_NAME__REQUEST');
export const getAttachmentPreviewByNameSuccess = createAction<PayloadData<any, GetAttachmentPreviewByName$Request>>('TRIGGER_ATTACHMENT_CONTROLLER__GET_ATTACHMENT_PREVIEW_BY_NAME__SUCCESS');
export const getAttachmentPreviewByNameFailure = createAction<PayloadData<void, GetAttachmentPreviewByName$Request, true>>('TRIGGER_ATTACHMENT_CONTROLLER__GET_ATTACHMENT_PREVIEW_BY_NAME__FAILURE');

export const getAttachmentPreviewByNameActions = [
    getAttachmentPreviewByNameRequest,
    getAttachmentPreviewByNameSuccess,
    getAttachmentPreviewByNameFailure
] as const;

/**
 * Returns the trigger attachment preview content
 * @param {string} meta.name UUID of the trigger attachment
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAttachmentPreviewByName = (meta: GetAttachmentPreviewByName$Request, config?: GetAttachmentPreviewByName$Config) => {
    return {
        DOWNLOAD_FILE: {
            types: getAttachmentPreviewByNameActions,
            method: ApiMethods.GET,
            endpoint: `/attachments/content/${meta.name}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'image/png',
            }
        },
        ...meta
    }
};

export interface RemoveTriggerAttachmentByName$Request {
    name: string;
    eventId: number;
}

export interface RemoveTriggerAttachmentByName$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const removeTriggerAttachmentByNameRequest = createAction<PayloadData<void, RemoveTriggerAttachmentByName$Request>>('TRIGGER_ATTACHMENT_CONTROLLER__REMOVE_TRIGGER_ATTACHMENT_BY_NAME__REQUEST');
export const removeTriggerAttachmentByNameSuccess = createAction<PayloadData<void, RemoveTriggerAttachmentByName$Request>>('TRIGGER_ATTACHMENT_CONTROLLER__REMOVE_TRIGGER_ATTACHMENT_BY_NAME__SUCCESS');
export const removeTriggerAttachmentByNameFailure = createAction<PayloadData<Error, RemoveTriggerAttachmentByName$Request, true>>('TRIGGER_ATTACHMENT_CONTROLLER__REMOVE_TRIGGER_ATTACHMENT_BY_NAME__FAILURE');

export const removeTriggerAttachmentByNameActions = [
    removeTriggerAttachmentByNameRequest,
    removeTriggerAttachmentByNameSuccess,
    removeTriggerAttachmentByNameFailure
] as const;

/**
 * Admin-only operation. Deletes attachment from bucket, preview folder, trigger_attachment table, and all change request attachment lists.
 * @param {string} meta.name Attachment name (UUID)
 * @param {number} meta.eventId ID of the event
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const removeTriggerAttachmentByName = (meta: RemoveTriggerAttachmentByName$Request, config?: RemoveTriggerAttachmentByName$Config) => {
    const TRANSPORT_GET_PARAMS = {
        eventId: meta.eventId,
    };
    return {
        CALL_API: {
            types: removeTriggerAttachmentByNameActions,
            method: ApiMethods.DELETE,
            endpoint: `/attachments/${meta.name}/remove`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StreamAttachmentByName$Request {
    name: string;
    range: string;
}

export interface StreamAttachmentByName$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const streamAttachmentByNameRequest = createAction<PayloadData<void, StreamAttachmentByName$Request>>('TRIGGER_ATTACHMENT_CONTROLLER__STREAM_ATTACHMENT_BY_NAME__REQUEST');
export const streamAttachmentByNameSuccess = createAction<PayloadData<string, StreamAttachmentByName$Request>>('TRIGGER_ATTACHMENT_CONTROLLER__STREAM_ATTACHMENT_BY_NAME__SUCCESS');
export const streamAttachmentByNameFailure = createAction<PayloadData<void, StreamAttachmentByName$Request, true>>('TRIGGER_ATTACHMENT_CONTROLLER__STREAM_ATTACHMENT_BY_NAME__FAILURE');

export const streamAttachmentByNameActions = [
    streamAttachmentByNameRequest,
    streamAttachmentByNameSuccess,
    streamAttachmentByNameFailure
] as const;

/**
 * Returns the trigger attachment content and supports HTTP byte range requests
 * @param {string} meta.name UUID of the trigger attachment
 * @param {string} meta.range Requested byte range (e.g. bytes&#x3D;0-1023)
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const streamAttachmentByName = (meta: StreamAttachmentByName$Request, config?: StreamAttachmentByName$Config) => {
    return {
        CALL_API: {
            types: streamAttachmentByNameActions,
            method: ApiMethods.GET,
            endpoint: `/attachments/content/${meta.name}/stream`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/octet-stream',
            }
        },
        ...meta
    }
};

export interface UploadTriggerAttachment$Request {
    file: File | File[];
}

export interface UploadTriggerAttachment$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
    onProgress?: (progress: ProgressEvent) => void;
}

export const uploadTriggerAttachmentRequest = createAction<PayloadData<void, UploadTriggerAttachment$Request>>('TRIGGER_ATTACHMENT_CONTROLLER__UPLOAD_TRIGGER_ATTACHMENT__REQUEST');
export const uploadTriggerAttachmentSuccess = createAction<PayloadData<UploadAttachmentResponse, UploadTriggerAttachment$Request>>('TRIGGER_ATTACHMENT_CONTROLLER__UPLOAD_TRIGGER_ATTACHMENT__SUCCESS');
export const uploadTriggerAttachmentFailure = createAction<PayloadData<Error, UploadTriggerAttachment$Request, true>>('TRIGGER_ATTACHMENT_CONTROLLER__UPLOAD_TRIGGER_ATTACHMENT__FAILURE');

export const uploadTriggerAttachmentActions = [
    uploadTriggerAttachmentRequest,
    uploadTriggerAttachmentSuccess,
    uploadTriggerAttachmentFailure
] as const;

/**
 * @param {any} meta.file The attachment file to upload
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 * @param {function(ProgressEvent): void} [config.onProgress]
 */
export const uploadTriggerAttachment = (meta: UploadTriggerAttachment$Request, config?: UploadTriggerAttachment$Config) => {
    const TRANSPORT_REQUEST_FILE = {
        file: meta.file,
    };
    return {
        UPLOAD_FILE: {
            types: uploadTriggerAttachmentActions,
            method: ApiMethods.POST,
            endpoint: `/attachments/save`,
            TRANSPORT_REQUEST_FILE,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            onProgress: config?.onProgress,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

